import React from "react";
import { Link } from "react-router-dom";
import CategoryCard from "../product/CategoryCard";
import { CategorySummary } from "../../types/store";

type CategorySectionProps = {
  categories: CategorySummary[];
  title: string;
  actionLabel?: string;
  actionTo?: string;
  className?: string;
  gridClassName?: string;
  showTitle?: boolean;
  showAction?: boolean;
  selectedCategoryKey?: string | null;
  selectedCategoryKeys?: string[];
  onCategoryClick?: (category: CategorySummary) => void;
};

const CategorySection: React.FC<CategorySectionProps> = ({
  categories,
  title,
  actionLabel = "See All",
  actionTo = "/categories",
  className = "home-category-section",
  gridClassName,
  showTitle = true,
  showAction = true,
  selectedCategoryKey = null,
  selectedCategoryKeys = [],
  onCategoryClick,
}) => {
  const sectionClassName = className.trim();
  const categoryGridClassName = ["category-grid", gridClassName?.trim()].filter(Boolean).join(" ");

  return (
    <section className={sectionClassName} aria-label={title}>
      {showTitle || (showAction && actionTo) ? (
        <div className="section-heading">
          {showTitle ? <h2>{title}</h2> : <span aria-hidden="true" />}
          {showAction && actionTo ? (
            <Link to={actionTo}>
              {actionLabel}
              <span aria-hidden="true">›</span>
            </Link>
          ) : null}
        </div>
      ) : null}
      <div className={categoryGridClassName}>
        {categories.map((category) => {
          const categoryKey = category.slug ?? category.name;
          const isSelected = selectedCategoryKeys.includes(categoryKey) || selectedCategoryKey === categoryKey;
          return (
            <CategoryCard
              key={category.id || category.name}
              category={category}
              selected={isSelected}
              onClick={onCategoryClick ? () => onCategoryClick(category) : undefined}
            />
          );
        })}
      </div>
    </section>
  );
};

export default CategorySection;
